(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('tikonApp')
        .constant('VERSION', "1.0-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('DEFAULT_VIDEO_CALL_URL', "https://meet.jit.si/RWB-")
;
})();
